import aliases from "./seo-hreflang.json" with { type: "json" };

// Search annotations use ISO 639-1 language codes. App locales, HTML lang,
// canonical paths and stored preferences retain their existing BCP 47 values.
// The Filipino translation is Tagalog-based; es covers our Latin American copy.
export function searchLanguageCode(locale: string): string {
  return (aliases as Record<string, string>)[locale] || locale;
}

export function normalizeHreflangAnnotations(html: string): string {
  return html.replace(/(\bhreflang\s*=\s*["'])([^"']+)(["'])/gi, (_tag, before, locale, after) => (
    `${before}${searchLanguageCode(locale)}${after}`
  ));
}
